import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UpdateScrollingText.css';
import API_URL from '../../api/ExamCalendarApi';

const ScrollingTextManager = () => {
  const [scrollingTexts, setScrollingTexts] = useState([]);
  const [text, setText] = useState('');
  const [link, setLink] = useState('');
  const [editingText, setEditingText] = useState(null);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  // Fetch all scrolling texts
  const fetchScrollingTexts = async () => {
    try {
      const response = await axios.get(`${API_URL}/homepage/all-scrolling-text`);
      setScrollingTexts(response.data.scrollingTexts || []); // Ensure it's an array
    } catch (error) {
      console.error('Error fetching scrolling texts:', error);
      setError('Failed to fetch scrolling texts');
    }
  };

  useEffect(() => {
    fetchScrollingTexts();
  }, []);

  // Create a new scrolling text
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!text) {
      alert('Text is required');
      return;
    }

    try {
      const newScrollingText = { text, link };
      await axios.post(`${API_URL}/homepage/create-scrolling-text`, newScrollingText);
      setSuccessMessage('Scrolling text created successfully!');
      fetchScrollingTexts();
      setText('');
      setLink('');
    } catch (error) {
      console.error('Error creating scrolling text:', error);
      setError('Failed to create scrolling text');
    }
  };

  // Set the scrolling text data to edit
  const handleEdit = (scrollingText) => {
    setEditingText(scrollingText);
    setText(scrollingText.text);
    setLink(scrollingText.link);
  };

  // Update the scrolling text
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!text) {
      alert('Text is required');
      return;
    }

    try {
      const updatedScrollingText = { text, link };
      await axios.put(`${API_URL}/homepage/update-scrolling-text/${editingText._id}`, updatedScrollingText);
      setSuccessMessage('Scrolling text updated successfully!');
      fetchScrollingTexts();
      setEditingText(null);
      setText('');
      setLink('');
    } catch (error) {
      console.error('Error updating scrolling text:', error);
      setError('Failed to update scrolling text');
    }
  };

  // Delete a scrolling text by ID
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/homepage/delete-scrolling-text/${id}`);
      setSuccessMessage('Scrolling text deleted successfully!');
      fetchScrollingTexts();
    } catch (error) {
      console.error('Error deleting scrolling text:', error);
      setError('Failed to delete scrolling text');
    }
  };

  return (
    <div className="admin-upcomingscrollingtext-container">
      <h1>Scrolling Notifications</h1>

      {error && <div className="admin-upcomingscrollingtext-alert error">{error}</div>}
      {successMessage && <div className="admin-upcomingscrollingtext-alert success">{successMessage}</div>}

      <form
        onSubmit={editingText ? handleUpdate : handleCreate}
        className="admin-upcomingscrollingtext-form"
      >
        <div className="admin-upcomingscrollingtext-form-group">
          <label htmlFor="text">Text</label>
          <input
            type="text"
            id="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Enter scrolling text"
          />
        </div>
        <div className="admin-upcomingscrollingtext-form-group">
          <label htmlFor="link">Link (optional)</label>
          <input
            type="text"
            id="link"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="Enter link (optional)"
          />
        </div>
        <button type="submit" className="admin-upcomingscrollingtext-button">
          {editingText ? 'Update Text' : 'Add Text'}
        </button>
      </form>

      <ul className="admin-upcomingscrollingtext-list">
        {scrollingTexts.length > 0 ? (
          scrollingTexts.map((scrollingText) => (
            <li key={scrollingText._id} className="admin-upcomingscrollingtext-list-item-wrapper">
              <div className="admin-upcomingscrollingtext-list-item">
              <div>
                <strong>{scrollingText.text}</strong> <br />
                {scrollingText.link && (
                  <a href={scrollingText.link} target="_blank" rel="noopener noreferrer">
                    Link
                  </a>
                )}
              </div>
              <div>
                <button
                  onClick={() => handleEdit(scrollingText)}
                  className="admin-upcomingscrollingtext-button edit"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(scrollingText._id)}
                  className="admin-upcomingscrollingtext-button delete"
                >
                  Delete
                </button>
              </div>
              </div>
            </li>
          ))
        ) : (
          <p>No scrolling texts available.</p>
        )}
      </ul>
    </div>
    
  );
};

export default ScrollingTextManager;
